<template>
  <f7-page @page:beforein="beforein">
    <navbar :text="$t('LeftPanel_subtitle_irrigation')" />
    <div class="info-watering-formula">
      {{ $t("Irrigation_title_mm") }}<br>
      {{ $t("Irrigation_title_grossDose") }}<br>
      {{ $t("Irrigation_title_wateringHours") }}
    </div>
    <DxIrrigation
      v-if="loaded"
      :default-irrigation-values="defaultIrrigationValues"
    />
    <f7-button
      class="button-next-screen"
      raised
      type="default"
      text-color="grey"
      styling-mode="outlined"
      @click="goToIrrigation"
    >
      {{ $t("Continue") }}
    </f7-button>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DxIrrigation from "../components/DxIrrigation.vue";
import navbar from "../components/NavBar.vue";

export default {
  components: {
    DxIrrigation,
    navbar,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    getIrrigationData() {
      return {
        currentAvailableVolume: this.currentAvailableVolume,
        currentIrrigationWaterCost: this.currentIrrigationWaterCost,
        currentMaximumIrrigation: this.currentMaximumIrrigation,
        currentMinimumIrrigation: this.currentMinimumIrrigation,
        currentMaximumIrrigationDose: this.currentMaximumIrrigationDose,
        currentMinimumIrrigationDose: this.currentMinimumIrrigationDose,
        currentEfficiency: this.currentEfficiency,
        currentSuboptimizationModel: this.currentSuboptimizationModel,
        currentNumberOfPointsInTheFunction:
          this.currentNumberOfPointsInTheFunction,
        currentInitialSoilMoisture: this.currentInitialSoilMoisture,
        currentSoilWaterFillLevel: this.currentSoilWaterFillLevel,
        currentSoilWaterDepletionLevel: this.currentSoilWaterDepletionLevel,
      };
    },
    ...mapState("Mopeco", [
      "currentAvailableVolume",
      "currentIrrigationWaterCost",
      "currentMaximumIrrigation",
      "currentMinimumIrrigation",
      "currentMaximumIrrigationDose",
      "currentMinimumIrrigationDose",
      "currentEfficiency",
      "suboptimizationModelOptions",
      "currentSuboptimizationModel",
      "currentNumberOfPointsInTheFunction",
      "currentInitialSoilMoisture",
      "currentSoilWaterFillLevel",
      "currentSoilWaterDepletionLevel",
      "defaultIrrigationValues",
    ]),
  },
  methods: {
    goToIrrigation() {
      const error = this.$helpers.validateIrrigationData(
        this.getIrrigationData
      );
      if (error !== "") {
        this.$f7.dialog.alert(this.$t(error));
        this.setShowCrops(false);
        return;
      }
      this.setShowCrops(true);
      this.$f7.views.main.router.navigate("/crops/");
    },
    async beforein() {
      this.$f7.preloader.show();
      try {
        await this.fetchDefaultIrrigationValues();
      } catch (error) {
        if (error.message.includes("500")) {
          this.$f7.dialog.alert(this.$t("error_500"));
        } else {
          this.$f7.dialog.alert(this.$t(`${error}`));
        }
      } finally {
        this.$f7.preloader.hide();
        this.loaded = true;
      }
    },
    ...mapActions("Mopeco", ["setShowCrops", "fetchDefaultIrrigationValues"]),
  },
};
</script>

<style>
.info-watering-formula {
padding: 10px;
color:#74838C;
}
</style>
